import { render, staticRenderFns } from "./OAButton.vue?vue&type=template&id=de09e19e&scoped=true&"
import script from "./OAButton.vue?vue&type=script&lang=js&"
export * from "./OAButton.vue?vue&type=script&lang=js&"
import style0 from "./OAButton.vue?vue&type=style&index=0&id=de09e19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de09e19e",
  null
  
)

export default component.exports